import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpBackend from 'i18next-http-backend';

// RTL language detection
const rtlLanguages = ['he', 'fa', 'ur'];

i18n
  .use(HttpBackend)
  .use(initReactI18next)
  .init({
    lng: 'en',
    fallbackLng: 'en',

    // Backend options for loading translation files
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
    },

    // Interpolation options
    interpolation: {
      escapeValue: false, // React already escapes by default
    },

    // Default namespace
    defaultNS: 'common',
    ns: ['common', 'auth', 'landing', 'dashboard'],

    // Development options
    debug: import.meta.env.DEV,

    // React options
    react: {
      useSuspense: false,
    },
  });

// Add RTL direction support
i18n.dir = (lng?: string) => {
  const language = lng || i18n.language;
  return rtlLanguages.includes(language) ? 'rtl' : 'ltr';
};

export default i18n;